
import React from "react";
import { Info } from "lucide-react";

const PuttingHelp = () => {
  const isLevel1 = window.location.pathname.includes('level1');
  const isLevel2 = window.location.pathname.includes('level2');
  
  let helpText = "";
  
  if (isLevel1) {
    helpText = "Points pour longues distances (niveau 1): Balle rentrée = 4pts, Balle à 1m du trou = 1pt, Balle à plus de 1m = 0pt";
  } else if (isLevel2) {
    helpText = "Points pour moyennes distances (niveau 2): Balle rentrée = 4pts, Balle à moins de 30cm = 2pts, Balle à plus de 30cm = 0pt";
  }

  return helpText ? (
    <div className="flex items-start gap-2 mb-4 text-blue-600 bg-blue-50 p-3 rounded-md">
      <Info className="h-5 w-5 mt-0.5 flex-shrink-0" />
      <p className="text-sm">
        {helpText}
      </p>
    </div>
  ) : null;
};

export default PuttingHelp;
